module.exports = __webpack_public_path__ + "img/Screen-R@2x.e24e7926.png";